// -----------------------------------------------------------------------------
// Gesprächstatus-Validierung
// -----------------------------------------------------------------------------

const init = () => {
  validateI2Form();
  validateIsnForm();
  validateBackendForm();
};

/**
 * Formular-Validierungen definieren
 */
const validateI2Form = () => {
  if ($('.js-gespraechstatus-form-i2').length) {
    checkI2Form();
    checkRequiredFields();
  }
};
const validateIsnForm = () => {
  if ($('.js-gespraechstatus-form-isn').length) {
    checkIsnForm();
    checkRequiredFields();
  }
};
const validateBackendForm = () => {
  if ($('.js-gespraechstatus-form-backend').length) {
    checkBackendForm();
  }
};

const checkI2Form = () => {
  $('.js-toggle-block').hide();
  $('input:checkbox').on('click', function () {
    if ($(this).is(':checked')) {
      $(this).parent().find('.js-toggle-block').toggle();
      $(this).parent().find('.js-toggle-block').find(':input').attr('required', true);
    } else {
      $(this).parent().find('.js-toggle-block').hide();
      $(this).parent().find('.js-toggle-block').find(':input').attr('required', false);
    }
  });

  $('input[type="checkbox"]').on('change', function () {
    $('[class*="' + this.className + '"]').not(this).prop('checked', false);
    $('[class*="' + this.className + '"]').not(this).parent().find('.js-toggle-block').hide();
    $('[class*="' + this.className + '"]').not(this).parent().find('.js-toggle-block').find(':input').attr('required', false);
  });
};

const checkIsnForm = () => {
  $('.js-toggle-block').hide();
  $('.js-other').hide();
  $('input:checkbox').on('click', function () {
    if ($(this).is(':checked')) {
      $(this).parent().find('.js-toggle-block').toggle();
      $(this).parent().find('.js-toggle-block').find(':input').attr('required', true);
    } else {
      $(this).parent().find('.js-toggle-block').hide();
      $(this).parent().find('.js-toggle-block').find(':input').attr('required', false);
    }
  });
  $('select').change(function () {
    var currentVal = $(this).val();
    if (currentVal === 'andere') {
      var dynamicInputName = $(this).parent().find('select').attr('name');
      $(this).parent().append($("<input type='text' />").attr('class', 'form-control hidden js-other ').attr('name', dynamicInputName));
      $(this).parent().find('.js-other').show();
      $(this).parent().find('.js-other').attr('required', true);
    } else {
      $(this).parent().find('.js-other').remove();
    }
  });

  $('input[type="checkbox"]').on('change', function () {
    $('[class*="' + this.className + '"]').not(this).prop('checked', false);
    $('[class*="' + this.className + '"]').not(this).parent().find('.js-toggle-block').hide();
    $('[class*="' + this.className + '"]').not(this).parent().find('.js-toggle-block').find(':input').attr('required', false);
  });
};

const checkRequiredFields = () => {
  $('.js-save-button').click(function (e) {
    var checkedGroups = [];
    // Check each group
    $(':checkbox[class*="js-chbox-"]').each(function () {
      var currentGroup = $(this).attr('class');
      if ($.inArray(currentGroup, checkedGroups) === -1) {
        var atLeastOneChecked = $('input[class*="' + currentGroup + '"]' + ':checked').length > 0;
        if (!atLeastOneChecked) {
          var errorMsg = 'Bitte wählen Sie einen Status.';
          var errorClassNr = currentGroup.match(/\d+$/)[0];
          $('.js-error-' + errorClassNr).html(errorMsg).show();
          e.preventDefault();
          return false;
        }
        checkedGroups.push(currentGroup);
      }
      return true;
    });
  });
};

const checkBackendForm = () => {
  $('input[name="form-type"]').click(function () {
    if ($(this).attr('class') === 'js-ev') {
      $('.js-event').show();
      $('.js-matchingDate').hide();
      $('.js-nonstartuparea input, .js-nonstartuparea select').removeAttr('required');
    } else if ($(this).attr('class') === 'js-dv') {
      $('.js-event').hide();
      $('.js-matchingDate').show();
      $('.js-nonstartuparea input, .js-nonstartuparea select').attr('required', true);
    }
  });

  $('form').on('submit', function () {
    if ($('.js-event').css('display') !== 'none') {
      if (parseInt($('input[name=programId]').val(), 10)  !== 32) {
        if ($('.js-event :checkbox:checked').length <= 0) {
          alert('Mindestens ein Programm muss ausgewählt werden!');
          return false;
        }
      }
      if (!$('.js-eventname').val()) {
        alert('Eventname fehlt!');
        return false;
      }
    }
    return true;
  });
};


export {
  init
};
